import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error:", location.pathname);

    // Add noindex for 404 pages
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    meta.setAttribute('data-seo', 'true');
    document.head.appendChild(meta);
    document.title = 'Página no encontrada | TECNOSYNC';

    return () => { meta.remove(); };
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-techno-dark flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 hero-grid opacity-30"></div>
      <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-techno-purple/20 rounded-full blur-3xl animate-float"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-techno-accent/15 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>

      <div className="text-center relative z-10 px-4">
        <h1 className="text-8xl md:text-9xl font-bold bg-gradient-to-r from-techno-purple to-techno-accent bg-clip-text text-transparent mb-4">
          404
        </h1>
        <p className="text-xl md:text-2xl text-gray-300 mb-2">Página no encontrada</p>
        <p className="text-gray-500 mb-8 max-w-md mx-auto">
          La página que buscas no existe o ha sido movida a otra ubicación.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button className="bg-gradient-to-r from-techno-purple to-techno-accent hover:opacity-90 rounded-full px-8">
              <Home className="w-4 h-4 mr-2" /> Ir al Inicio
            </Button>
          </Link>
          <Button variant="outline" onClick={() => window.history.back()} className="border-techno-purple/50 text-techno-accent hover:bg-techno-purple/20 rounded-full px-8">
            <ArrowLeft className="w-4 h-4 mr-2" /> Volver Atrás
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
